import { useState } from "react";
import { api, errMsg, useTitle } from "../lib";
import { PageHeader, Field, useHuman, Notice } from "../ui";

export default function Correction() {
  useTitle("Request a correction or removal");
  const human = useHuman();
  const [f, setF] = useState({ request_type: "correction", target: "", name: "", email: "", message: "" });
  const [state, setState] = useState({ sending: false, done: false, error: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setState({ sending: true, done: false, error: "" });
    try { await api.post("/submit/correction", { ...f, ...human.values }); setState({ sending: false, done: true, error: "" }); }
    catch (err) { setState({ sending: false, done: false, error: errMsg(err) }); human.reset(); }
  };
  return (
    <div data-testid="correction-page">
      <PageHeader eyebrow="Corrections" title="Request a correction or removal"
        intro="If something you shared, or something about you, should be changed or taken down, tell the family here. Requests go directly to them." />
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        {state.done ? <Notice testid="correction-success">Thank you. Your request has been sent to the family.</Notice> : (
          <form onSubmit={submit} className="space-y-5" data-testid="correction-form">
            <fieldset className="flex gap-6">
              <legend className="lou-label">I'd like to request</legend>
              {[["correction", "A correction"], ["removal", "A removal"]].map(([v, t]) => (
                <label key={v} className="flex items-center gap-2 cursor-pointer">
                  <input type="radio" name="rt" checked={f.request_type === v} onChange={() => setF({ ...f, request_type: v })} className="accent-[#4A4592]" data-testid={`correction-type-${v}`} />{t}
                </label>
              ))}
            </fieldset>
            <Field id="c-target" label="Which page or item" placeholder="Paste the link, or describe it" value={f.target} onChange={set("target")} data-testid="correction-target" />
            <div className="grid sm:grid-cols-2 gap-4">
              <Field id="c-name" label="Your name" required value={f.name} onChange={set("name")} data-testid="correction-name" />
              <Field id="c-email" label="Email (never published)" type="email" required value={f.email} onChange={set("email")} data-testid="correction-email" />
            </div>
            <Field id="c-msg" label="What should change" textarea required value={f.message} onChange={set("message")} data-testid="correction-message" />
            {human.ui}
            {state.error && <Notice kind="error" testid="correction-error">{state.error}</Notice>}
            <button className="lou-btn" disabled={state.sending} data-testid="correction-submit">{state.sending ? "Sending…" : "Send request"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
